<mat-card class="cur-card" formGroupName="supplyresumptionResultInfo">
    <mat-card-content style="margin-top: 1%; margin-left:1%;" class="tw-flex tw-flex-row tw-flex-wrap">
        <mat-radio-group color="warn" [disabled]=false
            class="customer-radio-group tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[100%]"
            style="position: relative;border: solid 1px rgba(0, 0, 0, 0.12); border-radius: 5px">
            <mat-label id="teishiJouhou"
                style="margin-left: 5px;padding-right: 3px;padding-left: 3px; position: absolute; top: -9px; font-size: 11px; color: rgba(0,0,0,0.6); background-color: white;">
                供給停止情報</mat-label>

            <div class="tw-flex tw-flex-row justify-evenly" style="margin-top: 2%; margin-left:2%;">
                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[45%]"
                    style="margin-left:2%;">
                    <mat-label>供給停止年月日</mat-label>
                    <input class="font-color-display-only" readonly="true" matInput [matDatepicker]="picker"
                        formControlName="supplystopYearmonthdate" maxlength="10">
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>

                <mat-form-field appearance="outline"
                    class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[45%]"
                    style="margin-left:2%;">
                    <mat-label>指針</mat-label>
                    <input class="font-color-display-only" readonly="true" matInput disabled="true" style="text-align:right;"
                        id="duringstopShishin" [value]="shishinInputTab.duringstopShishin">
                </mat-form-field>
            </div>
        </mat-radio-group>

        <div class="tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[100%]">
            <mat-form-field appearance="outline"
                class="input-form-basic-info tw-flex tw-flex-row box-border tw-grow tw-shrink tw-basis-full tw-max-w-[25%]"
                style="margin-top: 15px; margin-left:2%;">
                <mat-label>指針 *</mat-label>
                <input class="font-color-display-only" readonly="true" matInput id="onresumptionShishin" style="text-align:right;"
                    [value]="getControl('onresumptionShishin').value" />
            </mat-form-field>

            <div lass="tw-flex tw-flex-row">
                <button type="button" mat-raised-button color="primary" class="btn" id="shishinBtn"
                    style="margin-left: 50px; margin-top: 35px;" (click)="onClickShishinBtn()"
                    [disabled]="isDisableShishinBtn">
                    指針入力
                </button>
            </div>
        </div>
    </mat-card-content>
</mat-card>